import { quadsToGraph } from "../rdf.js";
import { resolveContext, resolveEngine } from "../global.js";
export class QueryEngineProxy {
    constructor(context, engine) {
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "engine", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.context = resolveContext(context);
        this.engine = resolveEngine(engine);
    }
    queryBoolean(query) {
        return this.engine.queryBoolean(query, this.context);
    }
    async queryBindings(query) {
        const bindingsStream = await this.engine.queryBindings(query, this.context);
        return bindingsStream.toArray();
    }
    async queryGraph(query) {
        const quadStream = await this.engine.queryQuads(query, this.context);
        const quads = await (quadStream.toArray());
        return quadsToGraph(quads);
    }
    queryVoid(query) {
        return this.engine.queryVoid(query, this.context);
    }
}
